import React, { useState, useEffect } from "react";
import { RiCloseFill } from "react-icons/ri";
import Select from "react-select";
import InputField from "../UI/InputField";
import TextArea from "../UI/TextArea";
import { post, get } from "../../utility/fetch";
import { get as gets } from "../../utility/fetchFinance";
import toast from "react-hot-toast";
import { BsTrash } from "react-icons/bs";
import SpeechToTextButton from "../UI/SpeechToTextButton";
import axios from "axios";
import GhostTextCompletion from "../UI/TextPrediction";
import { useSearchParams } from "react-router-dom";
import ReferPatientExternal from "./ReferPatientExternal";

function ReferPatient({
  closeModal,
  visit,
  vital,
  ivf,
  antenatal,
  cardiologyId,
  generalSurgery,
  familyMedcine,
  orthopedic,
  id,
  pediatricId,
  generalPractice,
  treatment,
  specialistExaminationId,
  ophthalmologyId,
  setRepeatedDiagnosis,
  repeatedDiagnosis,
  status,
  caseNoteData,
}) {
  const [searchParams] = useSearchParams();
  const appointmentId = searchParams.get("appointment");

  const [testRequests, setTestRequests] = useState([]);

  const [otherTestRequests, setOtherTestRequests] = useState([]);
  const [loading, setLoading] = useState(false);
  const [diagnosis, setDiagnosis] = useState("");
  const [additionalNote, setAdditionalNote] = useState("");
  const [labTest, setLabTest] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [hmo, setHmo] = useState(null);
  const [selectedLab, setSelectedLab] = useState(null);
  const [services, setServices] = useState(null);
  const [service, setService] = useState({});
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({});

  // New discount states
  const [discountRequested, setDiscountRequested] = useState(false);
  const [discountComments, setDiscountComments] = useState("");

  const [labType, setLabType] = useState([
    {
      value: 1,
      label: "Internal Lab",
    },
    {
      value: 2,
      label: "External Lab",
    },
  ]);

  const dummyLabCategories = [
    { value: 1, label: "Blood Test" },
    { value: 2, label: "Urine Test" },
    { value: 3, label: "X-Ray" },
    { value: 4, label: "CT Scan" },
  ];

  useEffect(() => {
    console.log(vital);

    setCategoryOptions(dummyLabCategories);
    fetchPatientHMO();
    getCategories();
    getInternalLabServices();
  }, []);

  // useEffect(() => {
  //   if (category) {
  //     // getCategoriesService();
  //     console.log(vital);
  //   }
  // }, [category, selectedLab]);

  useEffect(() => {
    setDiagnosis(repeatedDiagnosis);
    console.log(repeatedDiagnosis);
    console.log(vital);
  }, [repeatedDiagnosis]);

  const fetchPatientHMO = async () => {
    try {
      const response = await get(`/hmo/get-patient-hmo/${id}`);
      setHmo(response?.data[0]);
    } catch (error) {
      console.error("Error fetching HMO:", error);
    }
  };

  console.log(vital, "visit", visit);

  const getCategories = async () => {
    // const token = sessionStorage.getItem("token");

    // if (!token) {
    //   console.error("Token not found in session storage");
    //   return;
    // }

    // const options = {
    //   method: "GET",
    //   headers: {
    //     Authorization: `${token}`,
    //   },
    // };

    try {
      const res = await gets(`/category/list/1/1000`);

      console.log(res);

      const tempServices = res?.resultList
        // ?.filter(
        //   (service) =>
        //     service.name === "Lab Service" || service.name === "Lab Services"
        // )
        .map((category) => ({
          label: category?.name,
          value: parseFloat(category?.id),
        }));

      tempServices?.unshift({ label: "Select Service", value: "" });

      setCategories(tempServices);
    } catch (error) {
      console.error("Error fetching services:", error);
    }
  };

  // const getCategoriesService = async () => {
  //   // const token = sessionStorage.getItem("token");

  //   // if (!token) {
  //   //   console.error("Token not found in session storage");
  //   //   return;
  //   // }

  //   // const options = {
  //   //   method: "GET",
  //   //   headers: {
  //   //     Authorization: `${token}`,
  //   //   },
  //   // };

  //   try {
  //     setService({});
  //     setServices(null);
  //     const res = await gets(
  //       `/categoryitem/list/category/${category?.value}/1/1000`
  //     );
  //     console.log(res)

  //     const tempServices = res?.resultList.map((service) => ({
  //       label: service?.itemName,
  //       value: parseFloat(service?.id),
  //     }));

  //     tempServices?.unshift({ label: "Select Service", value: "" });

  //     setServices(tempServices);
  //   } catch (error) {
  //     console.error("Error fetching services:", error);
  //   }
  // };
  const getInternalLabServices = async (pageNumber = 1, pageSize = 3000) => {
    try {
      const res = await get(
        `/internallabservice/list/${pageNumber}/${pageSize}`
      );
      console.log("Internal lab services:", res);

      setServices(
        res?.data?.recordList.map((service) => ({
          label: service.name,
          value: parseFloat(service.id),
        }))
      );
      // return res;
    } catch (error) {
      console.error("Error fetching internal lab services:", error);
      return null;
    }
  };

  // Remove labCentre state and input
  // const [labCentre, setLabCentre] = useState(""); // REMOVE THIS LINE

  // When a Lab Service is selected, add to testRequests immediately
  const handleLabServiceSelect = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setService(selectedOption);
    if (selectedOption && selectedOption.value) {
      setTestRequests((prev) => [
        ...prev,
        {
          internalLabServiceId: selectedOption.value,
          labCentre: selectedOption.label || "Internal Lab",
        },
      ]);
      setSelectedCategory(null);
      setService(null);
    }
  };

  // Remove addLabRequest logic for internal lab
  const addLabRequest = () => {
    // Only for external lab (labTest)
    if (labTest.trim() !== "") {
      setOtherTestRequests([
        ...otherTestRequests,
        {
          labTest,
          labCentre: "External Lab",
        },
      ]);
      setLabTest("");
    } else {
      toast.error("Please fill in all required fields");
      return;
    }
  };

  const removeLabRequest = (index, isOther = false) => {
    if (isOther) {
      const updated = [...otherTestRequests];
      updated.splice(index, 1);
      setOtherTestRequests(updated);
    } else {
      const updated = [...testRequests];
      updated.splice(index, 1);
      setTestRequests(updated);
    }
  };

  const referPatient = async () => {
    if (testRequests.length === 0 && otherTestRequests.length === 0) {
      toast.error("Please add at least one test request");
      return;
    }
    if (diagnosis === "" || additionalNote === "") {
      toast.error("Please fill in all required fields");
      return;
    }

    // Validate discount comments if discount is requested
    if (discountRequested && !discountComments.trim()) {
      toast.error("Please provide comments for the discount request");
      return;
    }

    console.log(vital);
    console.log(visit);

    const selectedVital = vital?.find(
      (v) =>
        v.appointmentId === +localStorage.getItem("appointmentId") ||
        v.appointmentId === +appointmentId
    );

    console.log(selectedVital);

    const baseInternalLab =
      testRequests?.length > 0
        ? {
            diagnosis,
            isFamilyMedicine: familyMedcine ? true : false,
            dateOfVisit: new Date(visit?.appointDate).toISOString(),
            appointmentId: +appointmentId || visit?.id,
            hmoId: caseNoteData?.patientHmoId || 0,
            hmoPackageId: caseNoteData?.patientHmoId
              ? hmo?.hmoPackageId
              : 0 || 0,
            patientHmoId: caseNoteData?.patientHmoId || 0,
            hmoCode: caseNoteData?.hmoCode || "string",
            hmoApprovalStatus: caseNoteData?.hmoApprovalStatus || false,
            testRequests,
            additionalNote,
            familyMedicineId: +familyMedcine || 0,
            oG_IVFId: ivf,
            oG_BirthRecordId: 0,
            orthopedicId: orthopedic || 0,
            generalSurgeryId: generalSurgery || 0,
            antenatalId: antenatal || 0,
            pediatricId: pediatricId || 0,
            generalPracticeId: generalPractice || 0,
            cardiologyId: cardiologyId || 0,
            specialistExaminationId: specialistExaminationId || 0,
            ophthalmologyId: ophthalmologyId || 0,
          }
        : null;

    const baseExternalLab =
      otherTestRequests?.length > 0
        ? {
            diagnosis,
            isFamilyMedicine: familyMedcine ? true : false,
            dateOfVisit: new Date(visit?.appointDate).toISOString(),
            appointmentId: visit?.id,
            otherTestRequests,
            additionalNote,
            familyMedicineId: +familyMedcine || 0,
            oG_IVFId: ivf,
            oG_BirthRecordId: 0,
            orthopedicId: orthopedic || 0,
            generalSurgeryId: generalSurgery || 0,
            antenatalId: antenatal || 0,
            pediatricId: 0,
            generalPracticeId: 0,
            cardiologyId: 0,
          }
        : null;

    const payload = {
      labRequestType: selectedLab?.value,
      internalLab: baseInternalLab
        ? {
            ...baseInternalLab,
            // Add discount fields if discount is requested
            ...(discountRequested && {
              discountRequested: true,
              comments: discountComments,
            }),
          }
        : null,
      externalLab: baseExternalLab
        ? {
            ...baseExternalLab,
            // Add discount fields if discount is requested
            ...(discountRequested && {
              discountRequested: true,
              comments: discountComments,
            }),
          }
        : null,
    };

    console.log(payload);
    // return;

    try {
      const res = await post(
        `/lab/${id}/vital/${selectedVital?.vitalId}/lab-request`,
        payload
      );

      console.log(res);
      toast.success("Lab request added successfully");
      closeModal();
    } catch (error) {
      toast.error("Error adding lab request");
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <div className="overlay">
      <RiCloseFill className="close-btn pointer" onClick={closeModal} />
      <div className="modal-box max-w-800">
        <div className="p-40">
          <h3 className="bold-text">Refer Patient to Lab</h3>
          <div className="m-t-20">
            <div className="flex gap-8 flex-col">
              <div>
                <label>Lab Type</label>
                <Select
                  options={labType}
                  value={selectedLab}
                  onChange={setSelectedLab}
                  placeholder="Select a Lab Type"
                  isClearable
                />
              </div>
              {selectedLab?.value === 1 && (
                <div className="m-t-20">
                  {Array.isArray(services) && (
                    <div className="m-t-20">
                      <label>Lab Services</label>
                      <Select
                        options={services}
                        value={service}
                        onChange={handleLabServiceSelect}
                        placeholder="Select a Lab Service"
                        isClearable
                      />

                      {testRequests.length > 0 && (
                        <>
                          <h4 className="m-t-20">Category Test Requests</h4>
                          <table className="bordered-table-2 m-t-10">
                            <thead>
                              <tr>
                                <th className="w-20">s/n</th>
                                <th className="w-40">Service</th>
                                {/* <th className="w-40">Lab Centre</th> */}
                                <th className="w-20">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {testRequests.map((request, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {
                                      services?.find(
                                        (opt) =>
                                          opt?.value ===
                                          request?.internalLabServiceId
                                      )?.label
                                    }
                                  </td>
                                  {/* <td>{request.labCentre}</td> */}
                                  <td>
                                    <BsTrash
                                      className="text-red pointer"
                                      onClick={() => removeLabRequest(index)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      )}

                      {otherTestRequests.length > 0 && (
                        <>
                          <h4 className="m-t-20">Other Test Requests</h4>
                          <table className="bordered-table-2 m-t-10">
                            <thead>
                              <tr>
                                <th className="w-20">s/n</th>
                                <th className="w-40">Lab Test</th>
                                <th className="w-40">Lab Centre</th>
                                <th className="w-20">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {otherTestRequests.map((request, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{request.labTest}</td>
                                  <td>{request.labCentre}</td>
                                  <td>
                                    <BsTrash
                                      className="text-red pointer"
                                      onClick={() =>
                                        removeLabRequest(index, true)
                                      }
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </>
                      )}

                      <TextArea
                        label="Diagnosis"
                        name="diagnosis"
                        value={diagnosis}
                        onChange={(e) => {
                          setDiagnosis(e.target.value);
                          setRepeatedDiagnosis(e.target.value);
                        }}
                      />

                      <div>
                        <GhostTextCompletion
                          label="Additional Note"
                          name="additionalNote"
                          value={additionalNote}
                          handleChange={(e) =>
                            setAdditionalNote(e.target.value)
                          }
                        />
                      </div>

                      {/* Discount Section */}
                      <div className="m-t-20">
                        <div className="flex align-items-center gap-10">
                          <input
                            type="checkbox"
                            id="discountToggle"
                            checked={discountRequested}
                            onChange={(e) => {
                              setDiscountRequested(e.target.checked);
                              if (!e.target.checked) {
                                // Clear discount comments when toggled off
                                setDiscountComments("");
                              }
                            }}
                          />
                          <label htmlFor="discountToggle" className="label">
                            Request Discount
                          </label>
                        </div>

                        {discountRequested && (
                          <div
                            className="m-t-10"
                            style={{
                              padding: "15px",
                              border: "1px solid #ddd",
                              borderRadius: "5px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            <h4 style={{ marginBottom: "15px" }}>
                              Discount Request
                            </h4>

                            <div className="w-100">
                              <GhostTextCompletion
                                label="Discount Comments *"
                                name="discountComments"
                                value={discountComments}
                                handleChange={(e) =>
                                  setDiscountComments(e.target.value)
                                }
                                placeholder="Please provide reason for discount request..."
                              />
                            </div>

                            {/* Discount Status Indicator */}
                            <div
                              className="m-t-10"
                              style={{
                                padding: "8px",
                                backgroundColor: "#fff3cd",
                                borderRadius: "4px",
                                fontSize: "14px",
                                color: "#856404",
                                border: "1px solid #ffeaa7",
                              }}
                            >
                              <strong>Note: </strong>
                              Discount request will be submitted for approval
                              with this lab request.
                            </div>
                          </div>
                        )}
                      </div>

                      <button
                        className="btn m-t-20 w-100"
                        onClick={referPatient}
                        disabled={loading}
                      >
                        Refer Patient to Lab
                      </button>
                    </div>
                  )}
                </div>
              )}

              {selectedLab?.value === 2 && (
                <>
                  {/* <p className="text-sm m-t-20">
                    Dont see a category? Specify the name of the lab test
                  </p>
                  <InputField
                    label="Lab Test"
                    name="labTest"
                    value={labTest}
                    disabled={selectedCategory ? true : false}
                    onChange={(e) => setLabTest(e.target.value)}
                  /> */}

                  <ReferPatientExternal/>
                </>
              )}
              {/* Lab Centre input removed */}
            </div>
            <div className="flex flex-h-end">
              {selectedLab?.value === 2 && (
                <button className="btn m-t-10" onClick={addLabRequest}>
                  + Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferPatient;
